





































import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { IDocumentImageSource } from "../../../../domain/document";
import { DialogMixin } from "../../../system/mixins";
import ImageFileUploader from "../ImageFileUploader.vue";

@Component({
  components: {
    uploader: ImageFileUploader,
  },
})
export default class ImageFileUploaderDialog extends Mixins(DialogMixin) {
  @Prop()
  name: string;

  @Prop()
  createImageSource: (imageText: string) => Promise<IDocumentImageSource>;

  data(): any {
    return {
      selectingSource: null as IDocumentImageSource,
      previewStyle: {} as any,
      selectedSource: null as IDocumentImageSource,
      isClearable: false,
    };
  }
  selectingSource: IDocumentImageSource;
  previewStyle: any;
  selectedSource: IDocumentImageSource;
  isClearable: boolean;

  get title(): string {
    return this.name + "選択";
  }

  get isImageUploaded(): boolean {
    return !!this.selectingSource && !!this.selectingSource.source;
  }

  async show(isClearable: boolean = false): Promise<IDocumentImageSource> {
    return this.showModal(async () => {
      this.selectingSource = null;
      this.selectedSource = null;
      this.isClearable = isClearable;
      await this.waitHidden();
      return this.selectedSource;
    });
  }

  onImageLoaded(): void {
    const preview = this.$refs.preview as HTMLImageElement;
    const isHeightLonger = (preview.naturalWidth < preview.naturalHeight);
    this.previewStyle = {
      display: "block",
      margin: "auto",
      width: isHeightLonger ? "auto" : "300px",
      height: isHeightLonger ? "300px" : "auto",
    };
  }

  select(): void {
    this.selectedSource = this.selectingSource;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }

  clear(): void {
    const repository = DomainRegistry.document.getDocumentRepository();
    repository.createEmptyImageSource()
    .then(s => {
      this.selectedSource = s;
      this.isVisible = false;
    });
  }
}
